module.exports = __webpack_public_path__ + "img/logo-header.9c150ba4.png";